<div class="scanner">
  <div *ngIf="configAccess[1]||configAccess[2]">
    <h2 class="section-heading"> {{'PARTNER.DASHBOARD.TITLE' | translate}}</h2>
    <p class="section-description">{{'PARTNER.DASHBOARD.DESCRIPTION' | translate }}</p>
    <div class="row">

      <!--begin::Scan for Points-->
      <div *ngIf="configAccess[1]" class="item item-wrapper col-md-4" (click)="openModalLoyalty()">
        <mat-card class="item-card loyalty-item-card" style="height:100%;">
          <mat-card-content>
            <div class="loyalty-item">{{ 'PARTNER.WIZARD.LOYALTY_TITLE' | translate }}</div>
          </mat-card-content>
        </mat-card>
      </div>
      <!--end::Scan for Points-->

      <!--begin::Loyalty Offers List-->
      <ng-container *ngIf="configAccess[1]&&offers">
        <div class="item item-wrapper col-md-4 offers" *ngFor="let item of offers" (click)="openModalOffer(item)">
          <sng-offer-little-card [offer]="item"></sng-offer-little-card>
        </div>
      </ng-container>
      <!--end::Loyalty Offers List-->

      <!--begin::Microcredit Campaigns List for Redeem-->
      <ng-container *ngIf="configAccess[2]&&microcreditRedeem">
        <div class="item item-wrapper col-md-4 microcredits" *ngFor="let item of microcreditRedeem"
          (click)="openModalRedeemCampaign(item)">
          <sng-microcredit_campaign-little-card [campaign]="item" type="'all'" action="redeem">
          </sng-microcredit_campaign-little-card>
        </div>
      </ng-container>
      <!--end::Microcredit Campaigns List-->

      <!--begin::Microcredit Campaigns List for Support-->
      <ng-container *ngIf="configAccess[2]&&microcreditSupport">
        <div class="item item-wrapper col-md-4 microcredits" *ngFor="let item of microcreditSupport"
          (click)="openModalSupportCampaign(item)">
          <sng-microcredit_campaign-little-card [campaign]="item" type="'all'" action="support">
          </sng-microcredit_campaign-little-card>
        </div>
      </ng-container>
      <!--end::Microcredit Campaigns List-->


    </div>
  </div>

  <br>
  <hr>
  <br>

  <!--begin::Posts/Events List(Carousel)-->
  <!-- <sng-posts_events-list-carousel type='all' *ngIf="configAccess[0]"></sng-posts_events-list-carousel> -->
  <!--end::Posts/Events List(Carousel)-->

  <div *ngIf="configAccess[1]||configAccess[2]">
    <h2 class="col-md-12 section-heading"> {{'PARTNER.DASHBOARD.STATISTICS.TITLE' | translate}}</h2>
    <p class="section-description">{{'PARTNER.DASHBOARD.STATISTICS.DESCRIPTION' | translate }}</p>
    <!--begin::Loyalty Statistics-->
    <sng-loyalty-statistics>
    </sng-loyalty-statistics>
    <!--end::Loyalty Statistics-->

  </div>

</div>